import Dashboard from '../Dashboard.vue'

export default [
    {
        path: '/dashboard',
        name: '/dashboard',
        meta: { layout: 'mystagit' },
        component: Dashboard,
    },
]